// Evidence Score Calculation (0-10 scale)
// Clinically reproducible scoring based on study counts
function calculateEvidenceScore(metaAnalyses = 0, rcts = 0, otherStudies = 0) {
  const maPoints = Math.log(1 + metaAnalyses);
  const rctPoints = Math.log(1 + rcts);
  const otherPoints = Math.log(1 + otherStudies);
  
  const raw = 0.4 * maPoints + 0.4 * rctPoints + 0.2 * otherPoints;
  // Normalize: 3.0 ≈ score if MA=10, RCT=50
  return Math.min(10, (raw / 3.0) * 10);
}

// Anti-Inflammatory Score Calculation (0-10 scale)
// Based on documented percentage reductions in inflammatory markers
function calculateAntiInflammatoryScore(reductions = {}) {
  // Convert percentage reductions to 0-10 subscores
  // 0% = 0, ≥40% = 10, linear in between
  const toSubscore = (percent) => Math.min(10, Math.max(0, (percent / 40) * 10));
  
  const weights = {
    esr: 0.35,    // Global marker, cheap, frequently reported
    crp: 0.25,    // Acute-phase, widely cited
    il6: 0.15,    // Upstream cytokine
    tnfa: 0.15,   // Cytokine, joint diseases
    nfkb: 0.10    // Master switch
  };
  
  let totalScore = 0;
  totalScore += weights.esr * toSubscore(reductions.esr || 0);
  totalScore += weights.crp * toSubscore(reductions.crp || 0);
  totalScore += weights.il6 * toSubscore(reductions.il6 || 0);
  totalScore += weights.tnfa * toSubscore(reductions.tnfa || 0);
  totalScore += weights.nfkb * toSubscore(reductions.nfkb || 0);
  
  return Math.round(totalScore * 10) / 10; // Round to 1 decimal
}

// Supplement data - 100 supplements with proper 0-10 scoring
const supplements = [
  {
    "id": "omega3",
    "name": "Fish Oil (EPA/DHA)",
    "category": "Omega-3",
    "description": "Essential fatty acids with powerful anti-inflammatory effects",
    "evidence": {
      "score": 9.2,
      "studies": 156
    },
    "recommendedDose": "2-4g EPA/DHA daily",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 9,
    "costPerDay": 0.75,
    "pillsPerDay": 2,
    "benefits": [
      "Reduces inflammatory markers",
      "Supports heart health",
      "Improves joint health"
    ],
    "sideEffects": [
      "Fishy aftertaste",
      "Mild GI upset"
    ],
    "forms": [
      "Fish oil",
      "Krill oil",
      "Algae oil"
    ],
    "interactions": []
  },
  {
    "id": "curcumin",
    "name": "Curcumin",
    "category": "Polyphenols",
    "description": "Active compound from turmeric with potent anti-inflammatory properties",
    "evidence": {
      "score": 9,
      "studies": 127
    },
    "recommendedDose": "500-1000mg with piperine",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 9,
    "costPerDay": 0.65,
    "pillsPerDay": 2,
    "benefits": [
      "Inhibits NF-κB pathway",
      "Reduces joint inflammation",
      "Antioxidant effects"
    ],
    "sideEffects": [
      "Mild GI upset",
      "May stain"
    ],
    "forms": [
      "Standard extract",
      "BCM-95",
      "Meriva",
      "Longvida"
    ],
    "interactions": [
      "anticoagulants"
    ]
  },
  {
    "id": "vitaminD",
    "name": "Vitamin D3",
    "category": "Vitamins",
    "description": "Essential vitamin that modulates immune response and inflammation",
    "evidence": {
      "score": 8.7,
      "studies": 156
    },
    "recommendedDose": "2000-4000 IU daily",
    "timing": "With fat-containing meal",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.15,
    "pillsPerDay": 1,
    "benefits": [
      "Immune modulation",
      "Reduces inflammatory cytokines",
      "Bone health"
    ],
    "sideEffects": [
      "None at recommended doses"
    ],
    "forms": [
      "D3 (cholecalciferol)",
      "D2 (ergocalciferol)"
    ],
    "interactions": []
  },
  {
    "id": "magnesium",
    "name": "Magnesium",
    "category": "Minerals",
    "description": "Essential mineral that helps regulate inflammatory response",
    "evidence": {
      "score": 7.9,
      "studies": 67
    },
    "recommendedDose": "200-400mg daily",
    "timing": "Evening or split doses",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.25,
    "pillsPerDay": 1,
    "benefits": [
      "Reduces CRP levels",
      "Muscle relaxation",
      "Better sleep"
    ],
    "sideEffects": [
      "Loose stools at high doses"
    ],
    "forms": [
      "Glycinate",
      "Citrate",
      "Malate",
      "Threonate"
    ],
    "interactions": []
  },
  {
    "id": "boswellia",
    "name": "Boswellia Serrata",
    "category": "Herbs",
    "description": "Herbal extract that inhibits 5-LOX inflammatory pathway",
    "evidence": {
      "score": 8,
      "studies": 34
    },
    "recommendedDose": "300-500mg AKBA daily",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.55,
    "pillsPerDay": 2,
    "benefits": [
      "Joint health",
      "Reduces 5-LOX activity",
      "GI inflammation"
    ],
    "sideEffects": [
      "Mild GI upset",
      "Rare allergic reactions"
    ],
    "forms": [
      "5-Loxin",
      "ApresFlex",
      "Standard extract"
    ],
    "interactions": []
  },
  {
    "id": "quercetin",
    "name": "Quercetin",
    "category": "Polyphenols",
    "description": "Flavonoid with anti-inflammatory and antihistamine properties",
    "evidence": {
      "score": 8,
      "studies": 67
    },
    "recommendedDose": "500-1000mg daily",
    "timing": "Empty stomach or with bromelain",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.45,
    "pillsPerDay": 2,
    "benefits": [
      "Reduces histamine",
      "Antioxidant",
      "Supports immunity"
    ],
    "sideEffects": [
      "Mild headaches",
      "Tingling extremities"
    ],
    "forms": [
      "Quercetin dihydrate",
      "Quercetin phytosome"
    ],
    "interactions": [
      "antibiotics"
    ]
  },
  {
    "id": "ginger",
    "name": "Ginger Extract",
    "category": "Herbs",
    "description": "Traditional anti-inflammatory herb that inhibits COX and LOX",
    "evidence": {
      "score": 8,
      "studies": 380
    },
    "recommendedDose": "1-2g extract daily",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.35,
    "pillsPerDay": 2,
    "benefits": [
      "Reduces muscle soreness",
      "GI support",
      "Joint health"
    ],
    "sideEffects": [
      "Heartburn",
      "Mild GI upset"
    ],
    "forms": [
      "Standardized extract",
      "Fresh root",
      "Powder"
    ],
    "interactions": [
      "anticoagulants"
    ]
  },
  {
    "id": "nac",
    "name": "N-Acetylcysteine (NAC)",
    "category": "Amino Acids",
    "description": "Precursor to glutathione with anti-inflammatory effects",
    "evidence": {
      "score": 8,
      "studies": 89
    },
    "recommendedDose": "600-1200mg daily",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.4,
    "pillsPerDay": 2,
    "benefits": [
      "Antioxidant",
      "Liver support",
      "Reduces oxidative stress"
    ],
    "sideEffects": [
      "Mild nausea",
      "Sulfur smell"
    ],
    "forms": [
      "Standard NAC",
      "Sustained-release"
    ],
    "interactions": [
      "nitroglycerin"
    ]
  },
  {
    "id": "vitaminC",
    "name": "Vitamin C",
    "category": "Vitamins",
    "description": "Antioxidant vitamin that modulates inflammatory response",
    "evidence": {
      "score": 7.5,
      "studies": 1900
    },
    "recommendedDose": "500-1000mg daily",
    "timing": "Split doses with meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.2,
    "pillsPerDay": 2,
    "benefits": [
      "Antioxidant",
      "Immune support",
      "Collagen synthesis"
    ],
    "sideEffects": [
      "GI upset at high doses",
      "Kidney stones risk"
    ],
    "forms": [
      "Ascorbic acid",
      "Ester-C",
      "Liposomal"
    ],
    "interactions": []
  },
  {
    "id": "resveratrol",
    "name": "Resveratrol",
    "category": "Polyphenols",
    "description": "Polyphenol that activates SIRT1 and reduces inflammation",
    "evidence": {
      "score": 7.3,
      "studies": 420
    },
    "recommendedDose": "150-500mg daily",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.85,
    "pillsPerDay": 1,
    "benefits": [
      "Cardiovascular health",
      "Anti-aging",
      "Neuroprotection"
    ],
    "sideEffects": [
      "Mild GI upset",
      "Interactions with medications"
    ],
    "forms": [
      "Trans-resveratrol",
      "Micronized",
      "Pterostilbene"
    ],
    "interactions": [
      "anticoagulants",
      "nsaids"
    ]
  },
  {
    "id": "greentea",
    "name": "Green Tea Extract (EGCG)",
    "category": "Polyphenols",
    "description": "Catechins with anti-inflammatory and antioxidant properties",
    "evidence": {
      "score": 7.7,
      "studies": 890
    },
    "recommendedDose": "300-500mg EGCG daily",
    "timing": "Between meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.3,
    "pillsPerDay": 1,
    "benefits": [
      "Metabolic health",
      "Antioxidant",
      "Fat oxidation"
    ],
    "sideEffects": [
      "Caffeine effects",
      "Liver concerns at high doses"
    ],
    "forms": [
      "Standardized extract",
      "Decaffeinated",
      "Matcha"
    ],
    "interactions": [
      "stimulants"
    ]
  },
  {
    "id": "bromelain",
    "name": "Bromelain",
    "category": "Enzymes",
    "description": "Proteolytic enzyme from pineapple with anti-inflammatory effects",
    "evidence": {
      "score": 7,
      "studies": 280
    },
    "recommendedDose": "500-1000mg daily",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.5,
    "pillsPerDay": 2,
    "benefits": [
      "Reduces swelling",
      "Sinus health",
      "Digestive support"
    ],
    "sideEffects": [
      "Allergic reactions",
      "GI upset"
    ],
    "forms": [
      "2400 GDU/g",
      "Combination formulas"
    ],
    "interactions": [
      "anticoagulants",
      "antibiotics"
    ]
  },
  {
    "id": "zinc",
    "name": "Zinc",
    "category": "Minerals",
    "description": "Essential mineral that regulates immune and inflammatory response",
    "evidence": {
      "score": 7.6,
      "studies": 1100
    },
    "recommendedDose": "15-30mg daily",
    "timing": "Empty stomach or bedtime",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.15,
    "pillsPerDay": 1,
    "benefits": [
      "Immune function",
      "Wound healing",
      "Antioxidant"
    ],
    "sideEffects": [
      "Nausea on empty stomach",
      "Copper depletion"
    ],
    "forms": [
      "Picolinate",
      "Glycinate",
      "Citrate"
    ],
    "interactions": [
      "copper",
      "antibiotics"
    ]
  },
  {
    "id": "selenium",
    "name": "Selenium",
    "category": "Minerals",
    "description": "Trace mineral that supports antioxidant enzymes",
    "evidence": {
      "score": 6.8,
      "studies": 450
    },
    "recommendedDose": "200mcg daily",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 5,
    "costPerDay": 0.1,
    "pillsPerDay": 1,
    "benefits": [
      "Thyroid support",
      "Antioxidant",
      "Immune function"
    ],
    "sideEffects": [
      "Garlic breath",
      "Hair loss at high doses"
    ],
    "forms": [
      "Selenomethionine",
      "Selenium yeast"
    ],
    "interactions": []
  },
  {
    "id": "astaxanthin",
    "name": "Astaxanthin",
    "category": "Antioxidants",
    "description": "Powerful carotenoid antioxidant with anti-inflammatory effects",
    "evidence": {
      "score": 7.3,
      "studies": 28
    },
    "recommendedDose": "4-12mg daily",
    "timing": "With fat-containing meal",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.6,
    "pillsPerDay": 1,
    "benefits": [
      "Skin health",
      "Eye health",
      "Exercise recovery"
    ],
    "sideEffects": [
      "Orange skin tint at high doses"
    ],
    "forms": [
      "Natural from algae",
      "Synthetic"
    ],
    "interactions": []
  },
  {
    "id": "blackseed",
    "name": "Black Seed Oil",
    "category": "Herbs",
    "description": "Traditional remedy with thymoquinone as active compound",
    "evidence": {
      "score": 6.5,
      "studies": 180
    },
    "recommendedDose": "1-2 tsp daily",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.4,
    "pillsPerDay": 2,
    "benefits": [
      "Respiratory health",
      "Metabolic support",
      "Antimicrobial"
    ],
    "sideEffects": [
      "GI upset",
      "Blood sugar effects"
    ],
    "forms": [
      "Cold-pressed oil",
      "Standardized extract"
    ],
    "interactions": [
      "diabetes medications"
    ]
  },
  {
    "id": "spirulina",
    "name": "Spirulina",
    "category": "Other",
    "description": "Blue-green algae with anti-inflammatory and antioxidant properties",
    "evidence": {
      "score": 6.4,
      "studies": 250
    },
    "recommendedDose": "3-8g daily",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 5,
    "costPerDay": 0.45,
    "pillsPerDay": 6,
    "benefits": [
      "Nutrient dense",
      "Immune support",
      "Detoxification"
    ],
    "sideEffects": [
      "GI upset",
      "Detox reactions"
    ],
    "forms": [
      "Powder",
      "Tablets",
      "Hawaiian",
      "Organic"
    ],
    "interactions": []
  },
  {
    "id": "probiotics",
    "name": "Probiotics",
    "category": "Other",
    "description": "Beneficial bacteria that modulate inflammation through gut health",
    "evidence": {
      "score": 7.9,
      "studies": 950
    },
    "recommendedDose": "10-50 billion CFU daily",
    "timing": "Empty stomach or bedtime",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.55,
    "pillsPerDay": 1,
    "benefits": [
      "Gut health",
      "Immune modulation",
      "Mental health"
    ],
    "sideEffects": [
      "Initial bloating",
      "Gas"
    ],
    "forms": [
      "Multi-strain",
      "Spore-based",
      "Refrigerated"
    ],
    "interactions": []
  },
  {
    "id": "vitaminE",
    "name": "Vitamin E",
    "category": "Vitamins",
    "description": "Fat-soluble antioxidant vitamin",
    "evidence": {
      "score": 7.5,
      "studies": 145
    },
    "recommendedDose": "200-400 IU mixed",
    "timing": "With fat-containing meal",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.3,
    "pillsPerDay": 1,
    "benefits": [
      "Antioxidant",
      "Skin health",
      "Immune function"
    ],
    "sideEffects": [
      "High doses may increase bleeding"
    ],
    "forms": [
      "Mixed tocopherols",
      "Tocotrienols"
    ],
    "interactions": [
      "Blood thinners",
      "Statins"
    ]
  },
  {
    "id": "glucosamine",
    "name": "Glucosamine",
    "category": "Other",
    "description": "Joint support supplement with anti-inflammatory effects",
    "evidence": {
      "score": 7.5,
      "studies": 118
    },
    "recommendedDose": "1500mg daily",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.5,
    "pillsPerDay": 1,
    "benefits": [
      "Joint health",
      "Cartilage support",
      "Reduces joint inflammation"
    ],
    "sideEffects": [
      "Mild GI upset"
    ],
    "forms": [
      "Sulfate",
      "HCl"
    ],
    "interactions": [
      "Warfarin"
    ]
  },
  {
    "id": "sulforaphane",
    "name": "Sulforaphane",
    "category": "Antioxidants",
    "description": "Potent Nrf2 activator from broccoli",
    "evidence": {
      "score": 8.9,
      "studies": 134
    },
    "recommendedDose": "40-60mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 9,
    "costPerDay": 1.5,
    "pillsPerDay": 1,
    "benefits": [
      "Activates Nrf2 pathway",
      "Reduces CRP",
      "Detoxification"
    ],
    "sideEffects": [
      "Mild GI effects"
    ],
    "forms": [
      "Broccoli seed extract"
    ],
    "interactions": []
  },
  {
    "id": "tart_cherry",
    "name": "Tart Cherry Extract",
    "category": "Polyphenols",
    "description": "Anthocyanin-rich extract",
    "evidence": {
      "score": 8.2,
      "studies": 78
    },
    "recommendedDose": "480mg extract",
    "timing": "Evening",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.85,
    "pillsPerDay": 2,
    "benefits": [
      "Exercise recovery",
      "Sleep quality",
      "Reduces ESR"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Concentrate",
      "Capsules"
    ],
    "interactions": []
  },
  {
    "id": "pea",
    "name": "PEA (Palmitoylethanolamide)",
    "category": "Other",
    "description": "Endogenous fatty acid amide",
    "evidence": {
      "score": 8.5,
      "studies": 145
    },
    "recommendedDose": "600-1200mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 1.3,
    "pillsPerDay": 2,
    "benefits": [
      "Pain reduction",
      "Mast cell stabilization"
    ],
    "sideEffects": [
      "None reported"
    ],
    "forms": [
      "Micronized PEA"
    ],
    "interactions": []
  },
  {
    "id": "melatonin",
    "name": "Melatonin",
    "category": "Other",
    "description": "Sleep hormone with anti-inflammatory properties",
    "evidence": {
      "score": 8.3,
      "studies": 167
    },
    "recommendedDose": "3-10mg",
    "timing": "Before bed",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.35,
    "pillsPerDay": 1,
    "benefits": [
      "Improves sleep",
      "Antioxidant",
      "Immune modulation"
    ],
    "sideEffects": [
      "Drowsiness",
      "Vivid dreams"
    ],
    "forms": [
      "Immediate release",
      "Extended release"
    ],
    "interactions": [
      "Sedatives"
    ]
  },
  {
    "id": "coq10",
    "name": "CoQ10 (Ubiquinol)",
    "category": "Antioxidants",
    "description": "Mitochondrial antioxidant",
    "evidence": {
      "score": 8,
      "studies": 156
    },
    "recommendedDose": "100-300mg",
    "timing": "With fat meal",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 1.2,
    "pillsPerDay": 1,
    "benefits": [
      "Heart health",
      "Energy",
      "Neuroprotection"
    ],
    "sideEffects": [
      "Rare GI upset"
    ],
    "forms": [
      "Ubiquinol",
      "Ubiquinone"
    ],
    "interactions": [
      "Warfarin"
    ]
  },
  {
    "id": "serrapeptase",
    "name": "Serrapeptase",
    "category": "Enzymes",
    "description": "Proteolytic enzyme",
    "evidence": {
      "score": 7.7,
      "studies": 67
    },
    "recommendedDose": "60,000-120,000 SPU",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.75,
    "pillsPerDay": 2,
    "benefits": [
      "Reduces inflammation",
      "Breaks down scar tissue"
    ],
    "sideEffects": [
      "Rare GI upset"
    ],
    "forms": [
      "Enteric-coated"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "krill_oil",
    "name": "Krill Oil",
    "category": "Omega-3",
    "description": "Phospholipid-bound omega-3s",
    "evidence": {
      "score": 8.5,
      "studies": 89
    },
    "recommendedDose": "1-2g daily",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 1.5,
    "pillsPerDay": 2,
    "benefits": [
      "Better absorbed than fish oil",
      "Contains astaxanthin"
    ],
    "sideEffects": [
      "Rare GI upset"
    ],
    "forms": [
      "Softgels"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "andrographis",
    "name": "Andrographis",
    "category": "Herbs",
    "description": "King of Bitters herb",
    "evidence": {
      "score": 7.8,
      "studies": 89
    },
    "recommendedDose": "400-600mg",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.7,
    "pillsPerDay": 2,
    "benefits": [
      "Immune support",
      "Antiviral",
      "Liver protection"
    ],
    "sideEffects": [
      "Bitter taste"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Immunosuppressants"
    ]
  },
  {
    "id": "lions_mane",
    "name": "Lion's Mane Mushroom",
    "category": "Mushrooms",
    "description": "Neuroprotective mushroom",
    "evidence": {
      "score": 7.6,
      "studies": 78
    },
    "recommendedDose": "1000-3000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.9,
    "pillsPerDay": 2,
    "benefits": [
      "Cognitive enhancement",
      "NGF production",
      "Gut health"
    ],
    "sideEffects": [
      "Rare skin rashes"
    ],
    "forms": [
      "Hot water extract"
    ],
    "interactions": []
  },
  {
    "id": "turkey_tail",
    "name": "Turkey Tail Mushroom",
    "category": "Mushrooms",
    "description": "Immune-modulating mushroom",
    "evidence": {
      "score": 7.8,
      "studies": 89
    },
    "recommendedDose": "1-3g extract",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.85,
    "pillsPerDay": 2,
    "benefits": [
      "Immune modulation",
      "Gut microbiome support"
    ],
    "sideEffects": [
      "Mild GI effects"
    ],
    "forms": [
      "PSK/PSP extract"
    ],
    "interactions": []
  },
  {
    "id": "vitamin_k2",
    "name": "Vitamin K2 (MK-7)",
    "category": "Vitamins",
    "description": "Fat-soluble vitamin",
    "evidence": {
      "score": 7.6,
      "studies": 67
    },
    "recommendedDose": "100-200mcg",
    "timing": "With fat meal",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.4,
    "pillsPerDay": 1,
    "benefits": [
      "Bone health",
      "Vascular health"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "MK-7",
      "MK-4"
    ],
    "interactions": [
      "Warfarin"
    ]
  },
  {
    "id": "alphalipoic",
    "name": "Alpha Lipoic Acid",
    "category": "Antioxidants",
    "description": "Universal antioxidant",
    "evidence": {
      "score": 7.4,
      "studies": 580
    },
    "recommendedDose": "300-600mg",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.35,
    "pillsPerDay": 1,
    "benefits": [
      "Blood sugar control",
      "Neuropathy"
    ],
    "sideEffects": [
      "Low blood sugar"
    ],
    "forms": [
      "R-lipoic acid"
    ],
    "interactions": [
      "Diabetes medications"
    ]
  },
  {
    "id": "pomegranate",
    "name": "Pomegranate Extract",
    "category": "Polyphenols",
    "description": "Ellagitannin-rich extract",
    "evidence": {
      "score": 7.9,
      "studies": 112
    },
    "recommendedDose": "500-1000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.85,
    "pillsPerDay": 2,
    "benefits": [
      "Vascular health",
      "NO production"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Statins"
    ]
  },
  {
    "id": "grape_seed",
    "name": "Grape Seed Extract",
    "category": "Polyphenols",
    "description": "OPC-rich extract",
    "evidence": {
      "score": 7.7,
      "studies": 98
    },
    "recommendedDose": "100-300mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.45,
    "pillsPerDay": 1,
    "benefits": [
      "Vascular protection",
      "Antioxidant"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "95% OPCs"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "pine_bark",
    "name": "Pine Bark Extract",
    "category": "Polyphenols",
    "description": "Maritime pine bark",
    "evidence": {
      "score": 7.9,
      "studies": 134
    },
    "recommendedDose": "100-200mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 1.2,
    "pillsPerDay": 2,
    "benefits": [
      "Circulation",
      "Skin health"
    ],
    "sideEffects": [
      "Rare GI upset"
    ],
    "forms": [
      "Pycnogenol"
    ],
    "interactions": [
      "Immunosuppressants"
    ]
  },
  {
    "id": "holy_basil",
    "name": "Holy Basil (Tulsi)",
    "category": "Herbs",
    "description": "Ayurvedic adaptogen",
    "evidence": {
      "score": 7.4,
      "studies": 67
    },
    "recommendedDose": "300-600mg",
    "timing": "Morning/evening",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.5,
    "pillsPerDay": 2,
    "benefits": [
      "Stress relief",
      "COX-2 inhibition"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "rhodiola",
    "name": "Rhodiola Rosea",
    "category": "Herbs",
    "description": "Arctic root adaptogen",
    "evidence": {
      "score": 7.6,
      "studies": 89
    },
    "recommendedDose": "200-400mg",
    "timing": "Morning",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.6,
    "pillsPerDay": 1,
    "benefits": [
      "Reduces stress",
      "Mental clarity"
    ],
    "sideEffects": [
      "Mild stimulation"
    ],
    "forms": [
      "SHR-5 extract"
    ],
    "interactions": [
      "Stimulants"
    ]
  },
  {
    "id": "milk_thistle",
    "name": "Milk Thistle",
    "category": "Herbs",
    "description": "Liver-protective herb",
    "evidence": {
      "score": 7.8,
      "studies": 112
    },
    "recommendedDose": "200-400mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.4,
    "pillsPerDay": 2,
    "benefits": [
      "Liver protection",
      "Detox support"
    ],
    "sideEffects": [
      "Mild laxative"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": []
  },
  {
    "id": "ashwagandha",
    "name": "Ashwagandha",
    "category": "Herbs",
    "description": "Ayurvedic adaptogen",
    "evidence": {
      "score": 8,
      "studies": 100
    },
    "recommendedDose": "600-1000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.6,
    "pillsPerDay": 2,
    "benefits": [
      "Stress reduction",
      "Cortisol balance"
    ],
    "sideEffects": [
      "Drowsiness"
    ],
    "forms": [
      "KSM-66",
      "Sensoril"
    ],
    "interactions": [
      "Thyroid medications"
    ]
  },
  {
    "id": "berberine",
    "name": "Berberine",
    "category": "Herbs",
    "description": "Alkaloid with metabolic benefits",
    "evidence": {
      "score": 8.5,
      "studies": 145
    },
    "recommendedDose": "500mg 3x daily",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.9,
    "pillsPerDay": 3,
    "benefits": [
      "Blood sugar control",
      "AMPK activation"
    ],
    "sideEffects": [
      "GI upset"
    ],
    "forms": [
      "HCl",
      "Phytosome"
    ],
    "interactions": [
      "Diabetes medications"
    ]
  },
  {
    "id": "reishi",
    "name": "Reishi Mushroom",
    "category": "Mushrooms",
    "description": "Mushroom of immortality",
    "evidence": {
      "score": 7.7,
      "studies": 89
    },
    "recommendedDose": "1000-2000mg",
    "timing": "Evening",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.9,
    "pillsPerDay": 2,
    "benefits": [
      "Immune modulation",
      "Sleep quality"
    ],
    "sideEffects": [
      "Mild dryness"
    ],
    "forms": [
      "Extract",
      "Spore oil"
    ],
    "interactions": [
      "Immunosuppressants"
    ]
  },
  {
    "id": "cordyceps",
    "name": "Cordyceps",
    "category": "Mushrooms",
    "description": "Energy-enhancing mushroom",
    "evidence": {
      "score": 7.5,
      "studies": 78
    },
    "recommendedDose": "1000-3000mg",
    "timing": "Morning",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 1.1,
    "pillsPerDay": 2,
    "benefits": [
      "ATP production",
      "Athletic performance"
    ],
    "sideEffects": [
      "Mild stimulation"
    ],
    "forms": [
      "CS-4 extract"
    ],
    "interactions": []
  },
  {
    "id": "chaga",
    "name": "Chaga Mushroom",
    "category": "Mushrooms",
    "description": "Antioxidant-rich mushroom",
    "evidence": {
      "score": 7.4,
      "studies": 67
    },
    "recommendedDose": "500-1500mg",
    "timing": "Morning",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 1,
    "pillsPerDay": 2,
    "benefits": [
      "Powerful antioxidant",
      "Immune support"
    ],
    "sideEffects": [
      "May lower blood sugar"
    ],
    "forms": [
      "Hot water extract"
    ],
    "interactions": [
      "Diabetes medications"
    ]
  },
  {
    "id": "shiitake",
    "name": "Shiitake Mushroom",
    "category": "Mushrooms",
    "description": "Culinary medicinal mushroom",
    "evidence": {
      "score": 7.3,
      "studies": 67
    },
    "recommendedDose": "1000-3000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.6,
    "pillsPerDay": 2,
    "benefits": [
      "Immune support",
      "Cholesterol reduction"
    ],
    "sideEffects": [
      "Rare skin reactions"
    ],
    "forms": [
      "AHCC",
      "Extract"
    ],
    "interactions": []
  },
  {
    "id": "maitake",
    "name": "Maitake Mushroom",
    "category": "Mushrooms",
    "description": "Immune-enhancing mushroom",
    "evidence": {
      "score": 7.5,
      "studies": 78
    },
    "recommendedDose": "1000-2000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.85,
    "pillsPerDay": 2,
    "benefits": [
      "Blood sugar regulation",
      "Weight management"
    ],
    "sideEffects": [
      "May lower blood sugar"
    ],
    "forms": [
      "D-fraction"
    ],
    "interactions": [
      "Diabetes medications"
    ]
  },
  {
    "id": "glycine",
    "name": "Glycine",
    "category": "Amino Acids",
    "description": "Simple amino acid",
    "evidence": {
      "score": 7.5,
      "studies": 89
    },
    "recommendedDose": "3-5g",
    "timing": "Before bed",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.3,
    "pillsPerDay": 1,
    "benefits": [
      "Sleep improvement",
      "Collagen synthesis"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Powder",
      "Capsules"
    ],
    "interactions": []
  },
  {
    "id": "taurine",
    "name": "Taurine",
    "category": "Amino Acids",
    "description": "Sulfur amino acid",
    "evidence": {
      "score": 7.4,
      "studies": 98
    },
    "recommendedDose": "1-3g",
    "timing": "Any time",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.25,
    "pillsPerDay": 1,
    "benefits": [
      "Cardiovascular support",
      "Eye health"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Powder",
      "Capsules"
    ],
    "interactions": []
  },
  {
    "id": "glutamine",
    "name": "L-Glutamine",
    "category": "Amino Acids",
    "description": "Gut health amino acid",
    "evidence": {
      "score": 7.6,
      "studies": 134
    },
    "recommendedDose": "5-10g",
    "timing": "Empty stomach",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.4,
    "pillsPerDay": 1,
    "benefits": [
      "Gut barrier repair",
      "Immune support"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Powder",
      "Capsules"
    ],
    "interactions": []
  },
  {
    "id": "arginine",
    "name": "L-Arginine",
    "category": "Amino Acids",
    "description": "NO precursor",
    "evidence": {
      "score": 7.3,
      "studies": 112
    },
    "recommendedDose": "3-6g",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.35,
    "pillsPerDay": 3,
    "benefits": [
      "NO production",
      "Vascular health"
    ],
    "sideEffects": [
      "GI upset"
    ],
    "forms": [
      "L-arginine",
      "AAKG"
    ],
    "interactions": [
      "Blood pressure meds"
    ]
  },
  {
    "id": "carnitine",
    "name": "L-Carnitine",
    "category": "Amino Acids",
    "description": "Mitochondrial nutrient",
    "evidence": {
      "score": 7.5,
      "studies": 123
    },
    "recommendedDose": "2-3g",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.5,
    "pillsPerDay": 2,
    "benefits": [
      "Energy production",
      "Fat metabolism"
    ],
    "sideEffects": [
      "Fishy odor"
    ],
    "forms": [
      "L-carnitine",
      "Acetyl-L-carnitine"
    ],
    "interactions": [
      "Thyroid medications"
    ]
  },
  {
    "id": "citrulline",
    "name": "L-Citrulline",
    "category": "Amino Acids",
    "description": "Superior NO precursor",
    "evidence": {
      "score": 7.4,
      "studies": 89
    },
    "recommendedDose": "6-8g",
    "timing": "Pre-workout",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.4,
    "pillsPerDay": 1,
    "benefits": [
      "NO production",
      "Exercise performance"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "L-citrulline",
      "Citrulline malate"
    ],
    "interactions": []
  },
  {
    "id": "collagen",
    "name": "Collagen Peptides",
    "category": "Other",
    "description": "Structural protein",
    "evidence": {
      "score": 7.6,
      "studies": 134
    },
    "recommendedDose": "10-20g",
    "timing": "Any time",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 1,
    "pillsPerDay": 1,
    "benefits": [
      "Joint support",
      "Skin health"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Hydrolyzed",
      "Type II"
    ],
    "interactions": []
  },
  {
    "id": "creatine",
    "name": "Creatine Monohydrate",
    "category": "Amino Acids",
    "description": "ATP regeneration",
    "evidence": {
      "score": 8.5,
      "studies": 500
    },
    "recommendedDose": "3-5g",
    "timing": "Any time",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.2,
    "pillsPerDay": 1,
    "benefits": [
      "Muscle strength",
      "Brain energy"
    ],
    "sideEffects": [
      "Water retention"
    ],
    "forms": [
      "Monohydrate",
      "Creapure"
    ],
    "interactions": []
  },
  {
    "id": "spermidine",
    "name": "Spermidine",
    "category": "Other",
    "description": "Autophagy inducer",
    "evidence": {
      "score": 7.9,
      "studies": 56
    },
    "recommendedDose": "1-5mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 1.2,
    "pillsPerDay": 1,
    "benefits": [
      "Autophagy",
      "Longevity"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Wheat germ extract"
    ],
    "interactions": []
  },
  {
    "id": "urolithin_a",
    "name": "Urolithin A",
    "category": "Other",
    "description": "Pomegranate metabolite",
    "evidence": {
      "score": 8,
      "studies": 67
    },
    "recommendedDose": "250-500mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 2,
    "pillsPerDay": 1,
    "benefits": [
      "Mitophagy",
      "Muscle health"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Mitopure"
    ],
    "interactions": []
  },
  {
    "id": "butyrate",
    "name": "Butyrate",
    "category": "Other",
    "description": "Short-chain fatty acid",
    "evidence": {
      "score": 8,
      "studies": 134
    },
    "recommendedDose": "300-900mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 1,
    "pillsPerDay": 3,
    "benefits": [
      "Gut barrier",
      "HDAC inhibition"
    ],
    "sideEffects": [
      "Initial GI adjustment"
    ],
    "forms": [
      "Tributyrin"
    ],
    "interactions": []
  },
  {
    "id": "akkermansia",
    "name": "Akkermansia",
    "category": "Probiotics",
    "description": "Next-gen probiotic",
    "evidence": {
      "score": 8.1,
      "studies": 78
    },
    "recommendedDose": "10 billion CFU",
    "timing": "Empty stomach",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 1.5,
    "pillsPerDay": 1,
    "benefits": [
      "Metabolic health",
      "GLP-1"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Pasteurized"
    ],
    "interactions": []
  },
  {
    "id": "boron",
    "name": "Boron",
    "category": "Minerals",
    "description": "Trace mineral",
    "evidence": {
      "score": 7,
      "studies": 56
    },
    "recommendedDose": "3-10mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.15,
    "pillsPerDay": 1,
    "benefits": [
      "Bone health",
      "Hormone modulation"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Boron glycinate"
    ],
    "interactions": []
  },
  {
    "id": "chromium",
    "name": "Chromium",
    "category": "Minerals",
    "description": "Blood sugar mineral",
    "evidence": {
      "score": 7.3,
      "studies": 98
    },
    "recommendedDose": "200-400mcg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.15,
    "pillsPerDay": 1,
    "benefits": [
      "Blood sugar control",
      "Insulin sensitivity"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Picolinate"
    ],
    "interactions": [
      "Diabetes medications"
    ]
  },
  {
    "id": "pqq",
    "name": "PQQ",
    "category": "Other",
    "description": "Mitochondrial support",
    "evidence": {
      "score": 6.2,
      "studies": 120
    },
    "recommendedDose": "10-20mg",
    "timing": "With breakfast",
    "safetyRating": 4,
    "antiInflammatoryScore": 5,
    "costPerDay": 0.7,
    "pillsPerDay": 1,
    "benefits": [
      "Mitochondrial biogenesis",
      "Neuroprotection"
    ],
    "sideEffects": [
      "Insomnia if taken late"
    ],
    "forms": [
      "BioPQQ"
    ],
    "interactions": []
  },
  {
    "id": "willow_bark",
    "name": "White Willow Bark",
    "category": "Herbs",
    "description": "Natural aspirin precursor",
    "evidence": {
      "score": 7.3,
      "studies": 67
    },
    "recommendedDose": "240-480mg salicin",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.35,
    "pillsPerDay": 2,
    "benefits": [
      "Pain relief",
      "Fever reduction"
    ],
    "sideEffects": [
      "Stomach upset"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Blood thinners",
      "NSAIDs"
    ]
  },
  {
    "id": "cats_claw",
    "name": "Cat's Claw",
    "category": "Herbs",
    "description": "Amazonian vine",
    "evidence": {
      "score": 7.4,
      "studies": 67
    },
    "recommendedDose": "350-500mg",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.6,
    "pillsPerDay": 2,
    "benefits": [
      "TNF-α inhibition",
      "Immune modulation"
    ],
    "sideEffects": [
      "Headache"
    ],
    "forms": [
      "Inner bark extract"
    ],
    "interactions": [
      "Immune medications"
    ]
  },
  {
    "id": "devils_claw",
    "name": "Devil's Claw",
    "category": "Herbs",
    "description": "African anti-inflammatory",
    "evidence": {
      "score": 7.2,
      "studies": 56
    },
    "recommendedDose": "600-2400mg",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.5,
    "pillsPerDay": 3,
    "benefits": [
      "Joint pain relief",
      "Back pain"
    ],
    "sideEffects": [
      "GI upset"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Heart medications"
    ]
  },
  {
    "id": "feverfew",
    "name": "Feverfew",
    "category": "Herbs",
    "description": "Migraine prevention herb",
    "evidence": {
      "score": 7.5,
      "studies": 67
    },
    "recommendedDose": "100-300mg",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.45,
    "pillsPerDay": 1,
    "benefits": [
      "Migraine prevention",
      "Joint comfort"
    ],
    "sideEffects": [
      "Mouth ulcers"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "gotu_kola",
    "name": "Gotu Kola",
    "category": "Herbs",
    "description": "Ayurvedic cognitive herb",
    "evidence": {
      "score": 7.2,
      "studies": 89
    },
    "recommendedDose": "600-1200mg",
    "timing": "Morning/afternoon",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.6,
    "pillsPerDay": 2,
    "benefits": [
      "Circulation",
      "Cognitive support"
    ],
    "sideEffects": [
      "Drowsiness"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Sedatives"
    ]
  },
  {
    "id": "schisandra",
    "name": "Schisandra Berry",
    "category": "Herbs",
    "description": "Five-flavor berry",
    "evidence": {
      "score": 7.5,
      "studies": 67
    },
    "recommendedDose": "500-1500mg",
    "timing": "Morning",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.7,
    "pillsPerDay": 2,
    "benefits": [
      "Liver protection",
      "Stress adaptation"
    ],
    "sideEffects": [
      "Mild stimulation"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "P450 substrates"
    ]
  },
  {
    "id": "baicalin",
    "name": "Baicalin (Skullcap)",
    "category": "Herbs",
    "description": "Chinese skullcap flavonoid",
    "evidence": {
      "score": 7.9,
      "studies": 89
    },
    "recommendedDose": "250-500mg",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 8,
    "costPerDay": 0.85,
    "pillsPerDay": 2,
    "benefits": [
      "12-LOX inhibition",
      "Antiviral"
    ],
    "sideEffects": [
      "Drowsiness"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Sedatives"
    ]
  },
  {
    "id": "aged_garlic",
    "name": "Aged Garlic Extract",
    "category": "Herbs",
    "description": "Odorless garlic",
    "evidence": {
      "score": 7.7,
      "studies": 134
    },
    "recommendedDose": "600-1200mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.7,
    "pillsPerDay": 2,
    "benefits": [
      "Cardiovascular protection",
      "Immune support"
    ],
    "sideEffects": [
      "Rare GI upset"
    ],
    "forms": [
      "Kyolic"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "fisetin",
    "name": "Fisetin",
    "category": "Polyphenols",
    "description": "Senolytic flavonoid",
    "evidence": {
      "score": 7.8,
      "studies": 67
    },
    "recommendedDose": "100-500mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 1,
    "pillsPerDay": 1,
    "benefits": [
      "Senolytic",
      "Brain health"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": []
  },
  {
    "id": "apigenin",
    "name": "Apigenin",
    "category": "Polyphenols",
    "description": "Chamomile flavonoid",
    "evidence": {
      "score": 7.6,
      "studies": 89
    },
    "recommendedDose": "50-100mg",
    "timing": "Evening",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.7,
    "pillsPerDay": 1,
    "benefits": [
      "CD38 inhibition",
      "Sleep improvement"
    ],
    "sideEffects": [
      "Mild sedation"
    ],
    "forms": [
      "Extract"
    ],
    "interactions": [
      "Sedatives"
    ]
  },
  {
    "id": "luteolin",
    "name": "Luteolin",
    "category": "Polyphenols",
    "description": "Neuroinflammation fighter",
    "evidence": {
      "score": 7.5,
      "studies": 78
    },
    "recommendedDose": "100-200mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.85,
    "pillsPerDay": 2,
    "benefits": [
      "Mast cell stabilization",
      "NF-κB inhibition"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Pure luteolin"
    ],
    "interactions": []
  },
  {
    "id": "hesperidin",
    "name": "Hesperidin",
    "category": "Polyphenols",
    "description": "Citrus flavonoid",
    "evidence": {
      "score": 7.5,
      "studies": 89
    },
    "recommendedDose": "500-1000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.7,
    "pillsPerDay": 2,
    "benefits": [
      "Vascular protection",
      "Hemorrhoid relief"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Micronized"
    ],
    "interactions": []
  },
  {
    "id": "pterostilbene",
    "name": "Pterostilbene",
    "category": "Polyphenols",
    "description": "Methylated resveratrol",
    "evidence": {
      "score": 7.7,
      "studies": 67
    },
    "recommendedDose": "50-150mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 1,
    "pillsPerDay": 1,
    "benefits": [
      "SIRT1 activation",
      "Brain health"
    ],
    "sideEffects": [
      "May lower blood pressure"
    ],
    "forms": [
      "pTeroPure"
    ],
    "interactions": [
      "Blood pressure meds"
    ]
  },
  {
    "id": "hydroxytyrosol",
    "name": "Hydroxytyrosol",
    "category": "Polyphenols",
    "description": "Olive oil phenol",
    "evidence": {
      "score": 7.9,
      "studies": 89
    },
    "recommendedDose": "20-50mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 8,
    "costPerDay": 1,
    "pillsPerDay": 1,
    "benefits": [
      "Nrf2 activation",
      "Cardiovascular protection"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Mediteanox"
    ],
    "interactions": []
  },
  {
    "id": "ellagic_acid",
    "name": "Ellagic Acid",
    "category": "Polyphenols",
    "description": "Berry polyphenol",
    "evidence": {
      "score": 7.6,
      "studies": 78
    },
    "recommendedDose": "200-400mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.85,
    "pillsPerDay": 2,
    "benefits": [
      "DNA protection",
      "Anti-proliferative"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Pomegranate extract"
    ],
    "interactions": []
  },
  {
    "id": "mangosteen",
    "name": "Mangosteen Extract",
    "category": "Polyphenols",
    "description": "Xanthone-rich fruit",
    "evidence": {
      "score": 7.3,
      "studies": 56
    },
    "recommendedDose": "500-1000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.8,
    "pillsPerDay": 2,
    "benefits": [
      "Rich in xanthones",
      "Immune support"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Pericarp extract"
    ],
    "interactions": []
  },
  {
    "id": "bilberry",
    "name": "Bilberry Extract",
    "category": "Polyphenols",
    "description": "Eye health berry",
    "evidence": {
      "score": 7.2,
      "studies": 78
    },
    "recommendedDose": "160-480mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.6,
    "pillsPerDay": 2,
    "benefits": [
      "Eye health",
      "Vascular protection"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "elderberry",
    "name": "Elderberry",
    "category": "Polyphenols",
    "description": "Immune-supporting berry",
    "evidence": {
      "score": 7,
      "studies": 67
    },
    "recommendedDose": "500-1000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.5,
    "pillsPerDay": 2,
    "benefits": [
      "Immune support",
      "Antiviral"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": []
  },
  {
    "id": "hawthorn",
    "name": "Hawthorn",
    "category": "Herbs",
    "description": "Heart health herb",
    "evidence": {
      "score": 7.3,
      "studies": 89
    },
    "recommendedDose": "300-900mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.45,
    "pillsPerDay": 2,
    "benefits": [
      "Cardiovascular support",
      "Blood pressure"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Heart medications"
    ]
  },
  {
    "id": "betaine",
    "name": "Betaine (TMG)",
    "category": "Other",
    "description": "Methyl donor",
    "evidence": {
      "score": 7.2,
      "studies": 78
    },
    "recommendedDose": "1-3g",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.3,
    "pillsPerDay": 2,
    "benefits": [
      "Lowers homocysteine",
      "Liver health"
    ],
    "sideEffects": [
      "Body odor"
    ],
    "forms": [
      "TMG"
    ],
    "interactions": []
  },
  {
    "id": "nmn",
    "name": "NMN",
    "category": "Other",
    "description": "NAD+ precursor",
    "evidence": {
      "score": 8,
      "studies": 89
    },
    "recommendedDose": "250-500mg",
    "timing": "Morning",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 2,
    "pillsPerDay": 1,
    "benefits": [
      "NAD+ boost",
      "Mitochondrial function"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Sublingual"
    ],
    "interactions": []
  },
  {
    "id": "ergothioneine",
    "name": "Ergothioneine",
    "category": "Antioxidants",
    "description": "Unique mitochondrial antioxidant",
    "evidence": {
      "score": 7.8,
      "studies": 56
    },
    "recommendedDose": "5-25mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 1.5,
    "pillsPerDay": 1,
    "benefits": [
      "Mitochondrial protection",
      "Longevity"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "MitoPrime"
    ],
    "interactions": []
  },
  {
    "id": "chlorophyll",
    "name": "Chlorophyll",
    "category": "Antioxidants",
    "description": "Plant pigment",
    "evidence": {
      "score": 7,
      "studies": 45
    },
    "recommendedDose": "100-300mg",
    "timing": "Empty stomach",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.35,
    "pillsPerDay": 1,
    "benefits": [
      "Detoxification",
      "Body odor reduction"
    ],
    "sideEffects": [
      "Green stools"
    ],
    "forms": [
      "Chlorophyllin"
    ],
    "interactions": []
  },
  {
    "id": "proteolytic_blend",
    "name": "Proteolytic Enzyme Blend",
    "category": "Enzymes",
    "description": "Systemic enzymes",
    "evidence": {
      "score": 7.6,
      "studies": 78
    },
    "recommendedDose": "Per label",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 8,
    "costPerDay": 1.2,
    "pillsPerDay": 3,
    "benefits": [
      "Reduces inflammation",
      "Speeds recovery"
    ],
    "sideEffects": [
      "Rare GI upset"
    ],
    "forms": [
      "Enteric-coated"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "humic_fulvic",
    "name": "Humic/Fulvic Acid",
    "category": "Other",
    "description": "Mineral absorption enhancer",
    "evidence": {
      "score": 6.8,
      "studies": 34
    },
    "recommendedDose": "250-500mg",
    "timing": "Empty stomach",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.75,
    "pillsPerDay": 1,
    "benefits": [
      "Mineral absorption",
      "Detoxification"
    ],
    "sideEffects": [
      "Rare GI upset"
    ],
    "forms": [
      "Liquid"
    ],
    "interactions": []
  },
  {
    "id": "pau_darco",
    "name": "Pau d'Arco",
    "category": "Herbs",
    "description": "South American bark",
    "evidence": {
      "score": 6.9,
      "studies": 45
    },
    "recommendedDose": "1-2g bark",
    "timing": "Between meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.4,
    "pillsPerDay": 2,
    "benefits": [
      "Antimicrobial",
      "Immune support"
    ],
    "sideEffects": [
      "Nausea at high doses"
    ],
    "forms": [
      "Inner bark extract"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "sea_buckthorn",
    "name": "Sea Buckthorn Oil",
    "category": "Other",
    "description": "Omega-7 rich oil",
    "evidence": {
      "score": 7.4,
      "studies": 67
    },
    "recommendedDose": "2-4g oil",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.95,
    "pillsPerDay": 2,
    "benefits": [
      "Mucous membrane health",
      "Skin hydration"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Seed oil"
    ],
    "interactions": []
  },
  {
    "id": "hmb",
    "name": "HMB",
    "category": "Other",
    "description": "Leucine metabolite",
    "evidence": {
      "score": 7.2,
      "studies": 89
    },
    "recommendedDose": "3g",
    "timing": "Split doses",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.75,
    "pillsPerDay": 3,
    "benefits": [
      "Prevents muscle loss",
      "Recovery"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "HMB-Ca"
    ],
    "interactions": []
  },
  {
    "id": "l_reuteri",
    "name": "L. reuteri",
    "category": "Probiotics",
    "description": "Probiotic strain",
    "evidence": {
      "score": 7.7,
      "studies": 98
    },
    "recommendedDose": "1-5 billion CFU",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.5,
    "pillsPerDay": 1,
    "benefits": [
      "Oral health",
      "Gut health"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "DSM 17938"
    ],
    "interactions": []
  },
  {
    "id": "s_boulardii",
    "name": "S. boulardii",
    "category": "Probiotics",
    "description": "Beneficial yeast",
    "evidence": {
      "score": 7.8,
      "studies": 134
    },
    "recommendedDose": "5-10 billion CFU",
    "timing": "Any time",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.6,
    "pillsPerDay": 2,
    "benefits": [
      "Diarrhea prevention",
      "IBS support"
    ],
    "sideEffects": [
      "Rare fungemia"
    ],
    "forms": [
      "CNCM I-745"
    ],
    "interactions": [
      "Antifungals"
    ]
  },
  {
    "id": "b_longum",
    "name": "B. longum",
    "category": "Probiotics",
    "description": "Core gut probiotic",
    "evidence": {
      "score": 7.6,
      "studies": 112
    },
    "recommendedDose": "10-50 billion CFU",
    "timing": "Empty stomach",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.5,
    "pillsPerDay": 1,
    "benefits": [
      "Mood support",
      "Immune function"
    ],
    "sideEffects": [
      "Initial gas"
    ],
    "forms": [
      "BB536"
    ],
    "interactions": []
  },
  {
    "id": "sea_cucumber",
    "name": "Sea Cucumber",
    "category": "Other",
    "description": "Marine chondroitin",
    "evidence": {
      "score": 7.2,
      "studies": 56
    },
    "recommendedDose": "1000-3000mg",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 1,
    "pillsPerDay": 3,
    "benefits": [
      "Joint support",
      "COX-2 inhibition"
    ],
    "sideEffects": [
      "Seafood allergy"
    ],
    "forms": [
      "Dried extract"
    ],
    "interactions": [
      "Blood thinners"
    ]
  },
  {
    "id": "lithium_orotate",
    "name": "Lithium Orotate",
    "category": "Minerals",
    "description": "Trace mineral for brain",
    "evidence": {
      "score": 7.3,
      "studies": 78
    },
    "recommendedDose": "5-10mg",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.5,
    "pillsPerDay": 1,
    "benefits": [
      "Neuroprotection",
      "Mood stabilization"
    ],
    "sideEffects": [
      "Monitor at high doses"
    ],
    "forms": [
      "Orotate"
    ],
    "interactions": [
      "NSAIDs"
    ]
  },
  {
    "id": "copper",
    "name": "Copper",
    "category": "Minerals",
    "description": "Essential trace mineral",
    "evidence": {
      "score": 6.8,
      "studies": 89
    },
    "recommendedDose": "1-2mg",
    "timing": "Away from zinc",
    "safetyRating": 4,
    "antiInflammatoryScore": 5,
    "costPerDay": 0.1,
    "pillsPerDay": 1,
    "benefits": [
      "Enzyme function",
      "Iron metabolism"
    ],
    "sideEffects": [
      "Nausea"
    ],
    "forms": [
      "Glycinate"
    ],
    "interactions": [
      "Zinc"
    ]
  },
  {
    "id": "manganese",
    "name": "Manganese",
    "category": "Minerals",
    "description": "Trace mineral",
    "evidence": {
      "score": 6.5,
      "studies": 67
    },
    "recommendedDose": "2-5mg",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 5,
    "costPerDay": 0.1,
    "pillsPerDay": 1,
    "benefits": [
      "Bone health",
      "Antioxidant"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Glycinate"
    ],
    "interactions": [
      "Iron"
    ]
  },
  {
    "id": "vitamin_a",
    "name": "Vitamin A",
    "category": "Vitamins",
    "description": "Fat-soluble vitamin",
    "evidence": {
      "score": 7.2,
      "studies": 123
    },
    "recommendedDose": "5000-10000 IU",
    "timing": "With fat meal",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.15,
    "pillsPerDay": 1,
    "benefits": [
      "Immune function",
      "Vision"
    ],
    "sideEffects": [
      "Toxicity at high doses"
    ],
    "forms": [
      "Retinyl palmitate"
    ],
    "interactions": []
  },
  {
    "id": "b_complex",
    "name": "B-Complex",
    "category": "Vitamins",
    "description": "Complete B vitamins",
    "evidence": {
      "score": 7.4,
      "studies": 98
    },
    "recommendedDose": "1 complex",
    "timing": "Morning",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.35,
    "pillsPerDay": 1,
    "benefits": [
      "Energy",
      "Methylation"
    ],
    "sideEffects": [
      "Bright urine"
    ],
    "forms": [
      "Methylated"
    ],
    "interactions": []
  },
  {
    "id": "olive_leaf",
    "name": "Olive Leaf Extract",
    "category": "Herbs",
    "description": "Mediterranean herb",
    "evidence": {
      "score": 7.2,
      "studies": 78
    },
    "recommendedDose": "500-1000mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 7,
    "costPerDay": 0.5,
    "pillsPerDay": 2,
    "benefits": [
      "Blood pressure",
      "Antimicrobial"
    ],
    "sideEffects": [
      "None"
    ],
    "forms": [
      "Standardized extract"
    ],
    "interactions": [
      "Blood pressure meds"
    ]
  },
  {
    "id": "aloe_vera",
    "name": "Aloe Vera",
    "category": "Herbs",
    "description": "Soothing plant extract",
    "evidence": {
      "score": 7,
      "studies": 89
    },
    "recommendedDose": "200-400mg",
    "timing": "With meals",
    "safetyRating": 4,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.4,
    "pillsPerDay": 2,
    "benefits": [
      "GI health",
      "Skin healing"
    ],
    "sideEffects": [
      "Laxative effect"
    ],
    "forms": [
      "Inner leaf gel"
    ],
    "interactions": []
  },
  {
    "id": "dandelion",
    "name": "Dandelion",
    "category": "Herbs",
    "description": "Detox herb",
    "evidence": {
      "score": 6.8,
      "studies": 56
    },
    "recommendedDose": "500-1500mg",
    "timing": "With meals",
    "safetyRating": 5,
    "antiInflammatoryScore": 6,
    "costPerDay": 0.35,
    "pillsPerDay": 2,
    "benefits": [
      "Liver support",
      "Diuretic"
    ],
    "sideEffects": [
      "Increased urination"
    ],
    "forms": [
      "Root extract"
    ],
    "interactions": [
      "Diuretics"
    ]
  }
];

// Interaction data
const interactions = [
  {
    "supplements": [
      "omega3",
      "ginger"
    ],
    "severity": "mild",
    "description": "Both have blood-thinning effects. Monitor if on anticoagulants."
  },
  {
    "supplements": [
      "curcumin",
      "resveratrol"
    ],
    "severity": "mild",
    "description": "Both affect blood clotting. Monitor with blood thinners."
  },
  {
    "supplements": [
      "magnesium",
      "calcium"
    ],
    "severity": "mild",
    "description": "May compete for absorption. Take at different times."
  },
  {
    "supplements": [
      "zinc",
      "copper"
    ],
    "severity": "moderate",
    "description": "Zinc can deplete copper. Consider copper supplementation with long-term zinc use."
  },
  {
    "supplements": [
      "iron",
      "greentea"
    ],
    "severity": "moderate",
    "description": "Green tea can inhibit iron absorption. Take at different times."
  },
  {
    "supplements": [
      "vitamin_k2",
      "warfarin"
    ],
    "severity": "severe",
    "description": "Vitamin K antagonizes warfarin. Consult physician before use."
  },
  {
    "supplements": [
      "probiotics",
      "antibiotics"
    ],
    "severity": "moderate",
    "description": "Take probiotics 2-3 hours after antibiotics."
  }
];

// Stack templates for suggested combinations
const stackTemplates = [
  {
    "id": "beginner",
    "name": "Beginner Anti-Inflammatory Stack",
    "description": "Essential supplements for those new to anti-inflammatory protocols",
    "supplements": [
      "omega3",
      "vitaminD",
      "magnesium"
    ],
    "icon": "heart"
  },
  {
    "id": "joint",
    "name": "Joint Health Stack",
    "description": "Targeted support for joint pain and arthritis",
    "supplements": [
      "curcumin",
      "boswellia",
      "glucosamine",
      "omega3"
    ],
    "icon": "activity"
  },
  {
    "id": "gut",
    "name": "Gut Health Stack",
    "description": "Support for digestive health and gut inflammation",
    "supplements": [
      "probiotics",
      "glutamine",
      "curcumin",
      "zinc"
    ],
    "icon": "target"
  },
  {
    "id": "athletic",
    "name": "Athletic Recovery Stack",
    "description": "Reduce exercise-induced inflammation",
    "supplements": [
      "tart_cherry",
      "omega3",
      "curcumin",
      "bromelain"
    ],
    "icon": "zap"
  },
  {
    "id": "comprehensive",
    "name": "Comprehensive Protocol",
    "description": "Full spectrum anti-inflammatory support",
    "supplements": [
      "omega3",
      "curcumin",
      "resveratrol",
      "vitaminD",
      "probiotics",
      "nac"
    ],
    "icon": "shield"
  },
  {
    "id": "antioxidant",
    "name": "Antioxidant Power Stack",
    "description": "Focused on reducing oxidative stress and inflammation",
    "supplements": [
      "vitaminC",
      "vitaminE",
      "selenium",
      "alphalipoic",
      "astaxanthin",
      "resveratrol"
    ],
    "icon": "sun"
  }
];
